import {
  call,
  takeLatest
} from "redux-saga/effects";
import {
  downloadXLSFile
} from "utils/api";
import {
  defaultReturn,
  makePayload,
  generateDefaultActions
} from "store/utils/helpers";

export const EXPORT_LOAN_CONTACTS = generateDefaultActions("EXPORT_LOAN_CONTACTS");
export const exportLoanContacts = payload => makePayload(EXPORT_LOAN_CONTACTS.value, payload);
function* exportLoanContactsSaga(payload) {
  const url = `loans/${payload.id}/exportContacts`;
  yield call(downloadXLSFile, url, "POST", payload, "");
}

const initialState = {
  loanContacts: {

  }
};

export default function loanContactsReducer(state = initialState, action) {
  const {
    type,
    payload,
    subKey
  } = action;
  switch (type) {
    case EXPORT_LOAN_CONTACTS.success:
      return defaultReturn(state, payload.data, "loanContacts");
    default:
      return state;
  }
}

export function* loanContactsSaga() {
  yield takeLatest(EXPORT_LOAN_CONTACTS.value, exportLoanContactsSaga);
}
